const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/appointmentAttachment.ts';
import { KisApiAction } from '@cistec/common_web/defs/actionTypes';
import { getData, makeReducer2, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { actionLoadAppointmentsAttachments, LOAD_APPOINTMENT_ATTACHMENTS } from 'App/actions/appointmentAttachment';
import { selectAppointments } from './appointment';
import { useSelector } from 'react-redux';
import { PatAppStoreState } from './setup/rootReducer';

export interface AppointmentAttachment {
    filename: string;
    reportNr: string;
    sender: string;
    terminNr: string;
    type: 'KisReport' | 'KisPDF';
}

interface AppointmentsAttachments {
    [key: string]: AppointmentAttachment[];
}

const getAttachmentsData = (action: KisApiAction) => {
    const attachments = action.payload.result;
    const data: AppointmentsAttachments = {};
    attachments.forEach((attachment: AppointmentAttachment) => {
        data[attachment.terminNr] = data[attachment.terminNr] ?? [];
        data[attachment.terminNr].push(attachment);
    });
    return data;
};

export const appointmentAttachmentReducer = makeReducer2([
    [LOAD_APPOINTMENT_ATTACHMENTS, undefined, getAttachmentsData],
]);

// SELECTORS ==========================

const makeSelectAppointmentAttachments =
    (terminNr: string) =>
    (state: PatAppStoreState): AppointmentAttachment[] | undefined => {
        return getData(state.appointmentAttachment)?.[terminNr];
    };

// HOOKS ====================

export const useAppointmentAttachments = (terminNr: string) => {
    const appointments = useSelector(selectAppointments);

    return useRemoteData2('appointmentAttachment', {
        shouldRequest: !!appointments?.length,
        request: dispatch => {
            const terminNrs = appointments!.map(structuredAppointment => structuredAppointment.TERMNR);
            dispatch(actionLoadAppointmentsAttachments(terminNrs));
        },
        select: makeSelectAppointmentAttachments(terminNr),
    });
};
